import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'

const useStyles = makeStyles(() => ({
  megachip: {
    fontSize: 'var(--font-size-2xl)',
    backgroundColor: 'var(--color-primary-500)',
    color: 'var(--color-contrast-primary-500)',
    fontWeight: 'bolder',
    display: 'inline-block',
    borderRadius: 'var(--border-radius-sm)',
    padding: 'var(--padding-xs) var(--padding-lg)',
    border: 'var(--border-primary-thin)',
    boxShadow: 'var(--shadow-md)'
  }
}))

function MegaChip ({ children, className, style }) {
  const classes = useStyles()
  return (
    <div className={clsx(className, classes.megachip)} style={style}>
      {children}
    </div>
  )
}

MegaChip.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
}

export default MegaChip
